import { useMemo } from 'react'
import { MessageCircle } from 'lucide-react'

export default function WhatsAppFloatingButton() {
  const phone = '+91 7996337555'
  const waHref = useMemo(() => {
    const normalized = phone.replace(/[^0-9]/g, '')
    return `https://wa.me/${normalized}?text=${encodeURIComponent(
      'Hello Ritik Medicare, I would like to discuss API manufacturing / synthesis enquiry.'
    )}`
  }, [])

  return (
    <a
      href={waHref}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed left-4 bottom-24 sm:bottom-20 z-50 w-12 h-12 rounded-3xl bg-[#25D366] text-white shadow-lg flex items-center justify-center hover:brightness-110 transition"
    >
      <MessageCircle size={20} />
    </a>
  )
}

